import React, { createContext, useCallback, useContext, useState } from 'react'
import type { NewFilterStore } from '../table2/Filter3'

const noopRegister = () => () => {}

const ActiveFilterStoreContext = createContext<NewFilterStore | null>(null)
const RegisterActiveFilterStoreContext = createContext(noopRegister)

export const ActiveFilterStoreProvider: React.FC<{ children?: React.ReactNode }> = ({
    children,
}) => {
    const [activeStore, setActiveStore] = useState<NewFilterStore | null>(null)

    const register = useCallback((store: NewFilterStore) => {
        setActiveStore(store)
        return () => {
            // A later grid may already own the slot: only the store that still
            // holds it may clear it, otherwise an unmount blanks its successor.
            setActiveStore((current) => (current === store ? null : current))
        }
    }, [])

    return (
        <RegisterActiveFilterStoreContext.Provider value={register}>
            <ActiveFilterStoreContext.Provider value={activeStore}>
                {children}
            </ActiveFilterStoreContext.Provider>
        </RegisterActiveFilterStoreContext.Provider>
    )
}

export const useActiveFilterStore = (): NewFilterStore | null =>
    useContext(ActiveFilterStoreContext)

export const useRegisterActiveFilterStore = () => useContext(RegisterActiveFilterStoreContext)
